import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface ICSBulkOrderConsignInterface {
  splitReference?: string
}

export const useICSBulkOrderConsign = () => {
  const mutate = useMutation(
    ({ splitReference }: ICSBulkOrderConsignInterface) => {
      return postAPI(`ICSBulkConsignment/ConsignOrders`, {
        splitReference: splitReference,
      })
    },
  )

  return mutate
}

export default useICSBulkOrderConsign
